import { GeoPlacesClient } from "@aws-sdk/client-geo-places";
import { withAPIKey } from "@aws/amazon-location-utilities-auth-helper";

const region = process.env.REACT_APP_AUTH_REGION ?? "us-east-1";
const apiKey = process.env.REACT_APP_AWS_LOCATION_KEY!;
const auth = withAPIKey(apiKey, region);

let client: GeoPlacesClient | null = null;

export async function getPlacesClient() {
  if (!client) {
    client = new GeoPlacesClient(auth.getClientConfig());
  }
  return client!;
}
